import type * as Types from '../../types';

import gql from 'graphql-tag';
import type * as ApolloReactCommon from '@apollo/react-common';
import * as ApolloReactHooks from '@apollo/client';
export type GetStudiengangsForApplicantQueryVariables = Types.Exact<{
  order?: Types.Maybe<Array<Types.StudiengangSortInput> | Types.StudiengangSortInput>;
}>;


export type GetStudiengangsForApplicantQuery = { studiengangs: Array<{ __typename?: 'Studiengang', id: number, studiengangName?: Types.Maybe<string> }> };


export const GetStudiengangsForApplicantDocument = gql`
    query getStudiengangsForApplicant($order: [StudiengangSortInput!]) {
  studiengangs(order: $order) {
    id
    studiengangName
  }
}
    `;

/**
 * __useGetStudiengangsForApplicantQuery__
 *
 * To run a query within a React component, call `useGetStudiengangsForApplicantQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetStudiengangsForApplicantQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetStudiengangsForApplicantQuery({
 *   variables: {
 *      order: // value for 'order'
 *   },
 * });
 */
export function useGetStudiengangsForApplicantQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetStudiengangsForApplicantQuery, GetStudiengangsForApplicantQueryVariables>) {
        return ApolloReactHooks.useQuery<GetStudiengangsForApplicantQuery, GetStudiengangsForApplicantQueryVariables>(GetStudiengangsForApplicantDocument, baseOptions);
      }
export function useGetStudiengangsForApplicantLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetStudiengangsForApplicantQuery, GetStudiengangsForApplicantQueryVariables>) {
          return ApolloReactHooks.useLazyQuery<GetStudiengangsForApplicantQuery, GetStudiengangsForApplicantQueryVariables>(GetStudiengangsForApplicantDocument, baseOptions);
        }
export type GetStudiengangsForApplicantQueryHookResult = ReturnType<typeof useGetStudiengangsForApplicantQuery>;
export type GetStudiengangsForApplicantLazyQueryHookResult = ReturnType<typeof useGetStudiengangsForApplicantLazyQuery>;
export type GetStudiengangsForApplicantQueryResult = ApolloReactCommon.QueryResult<GetStudiengangsForApplicantQuery, GetStudiengangsForApplicantQueryVariables>;
export type PartialResultType<T> = Types.PartialResultType<T>;
export type ResultType<T> = Types.ResultType<T>;
export type NonMaybe<T> = Types.NonMaybe<T>;
